import React, { Component } from 'react'
import './index.less'
import score from 'src/helper/score'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'
import { isVoca } from 'src/helper/tool'

import CountDown from '../Countdown'

export default class extends Component {
  render() {
    let { language, lang, remaintime, kingSupporterData, kingSupporterMyData } = this.props
    let isRankRange = (index) => {
      if (kingSupporterMyData.rank == index + 4) {
        return 'active'
      } else {
        return ''
      }
    }
    return (
      <div>
        {/* this-week-top */}
        <div className="this-week">
          <div className="title">{lang.thisweek}</div>

          {/* 倒计时 */}
          <CountDown lang={lang} language={language} remaintime={remaintime} />

          <div className="this-week-rank">
            <div
              className="rank-2"
              onClick={jumpToUser.bind(this, kingSupporterData && kingSupporterData[1] && kingSupporterData[1].uid)}
            >
              <img src="/img/activity/pk/kk2.png" alt="" />
            </div>
            <div
              className="rank-1"
              onClick={jumpToUser.bind(this, kingSupporterData && kingSupporterData[0] && kingSupporterData[0].uid)}
            >
              <img src="/img/activity/pk/kk1.png" alt="" />
            </div>
            <div
              className="rank-3"
              onClick={jumpToUser.bind(this, kingSupporterData && kingSupporterData[2] && kingSupporterData[2].uid)}
            >
              <img src="/img/activity/pk/kk3.png" alt="" />
            </div>
          </div>
          <div className="rank2">
            <img src={kingSupporterData && kingSupporterData[1] && kingSupporterData[1].avatarurl || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="rank1">
            <img src={kingSupporterData && kingSupporterData[0] && kingSupporterData[0].avatarurl || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="rank3">
            <img src={kingSupporterData && kingSupporterData[2] && kingSupporterData[2].avatarurl || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="rank2-info">
            <div className="name">
              {(kingSupporterData && kingSupporterData[1] && kingSupporterData[1].nickname) || ''}
            </div>
            <div className="id">ID:{kingSupporterData && kingSupporterData[1] && kingSupporterData[1].duid}</div>
            <div className="money">
              <span>{score(kingSupporterData && kingSupporterData[1] && kingSupporterData[1].val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
          <div className="rank1-info">
            <div className="name">
              {(kingSupporterData && kingSupporterData[0] && kingSupporterData[0].nickname) || ''}
            </div>
            <div className="id">ID:{kingSupporterData && kingSupporterData[0] && kingSupporterData[0].duid}</div>
            <div className="money">
              <span>{score(kingSupporterData && kingSupporterData[0] && kingSupporterData[0].val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
          <div className="rank3-info">
            <div className="name">
              {(kingSupporterData && kingSupporterData[2] && kingSupporterData[2].nickname) || ''}
            </div>
            <div className="id">ID:{kingSupporterData && kingSupporterData[2] && kingSupporterData[2].duid}</div>
            <div className="money">
              <span>{score(kingSupporterData && kingSupporterData[2] && kingSupporterData[2].val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
        </div>
        {/* this-week-top */}

        {/* this-week-bottom */}
        <div className="select-list">
          {kingSupporterData &&
            kingSupporterData
              .filter((ele, index) => {
                return index > 2
              })
              .map((item, index) => {
                if (index <= 6) {
                  return (
                    <div className={`list ${isRankRange(index)} ${language == 'ar' && 'arlang'}`} key={index}>
                      <div className="id">{index + 4}</div>
                      <div
                        className="ava"
                        onClick={jumpToUser.bind(
                          this,
                          kingSupporterData && kingSupporterData[index + 3] && kingSupporterData[index + 3].uid
                        )}
                      >
                        <img src={item.avatarurl} alt="" />
                      </div>
                      <div className="info">
                        <div className="name">{item.nickname}</div>
                        <div className="info-id">
                          ID:
                          {item.duid}
                        </div>
                      </div>
                      <div className="money">
                        <span>{score(item.val)}</span>
                        <img src="/img/activity/pk/bs.png" alt="" />
                      </div>
                    </div>
                  )
                }
              })}

          <div className="list" style={{ display: `${kingSupporterData.length < 4 ? 'flex' : 'none'}` }}></div>
          {/* 我的 */}
          <div
            style={{ display: `${kingSupporterMyData.rank == '10+' ? 'flex' : 'none'}` }}
            className={`list myActive ${kingSupporterMyData.rank == '10+' ? 'active' : ''} ${language == 'ar' && 'arlang'
              } `}
          >
            <div className="id">{kingSupporterMyData.rank}</div>
            <div className="ava" onClick={jumpToUser.bind(this, kingSupporterMyData && kingSupporterMyData.uid)}>
              <img src={kingSupporterMyData.avatarurl} alt="" />
            </div>
            <div className="info">
              <div className="name">{kingSupporterMyData.nickname || ''}</div>
              <div className="info-id">ID:{kingSupporterMyData.duid}</div>
            </div>
            <div className="money">
              <span>{score(kingSupporterMyData.val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
        </div>

        <div className="last-select"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/RankThisWeek/index.js